import { gql } from '@apollo/client'

export const GET_GATE_WAY_LIST = gql`
  query GatewayList($input: GatewayListInput!) {
    gatewayList(input: $input) {
      ID
      gateWayType
      gateWayNumber
    }
  }
`
